<template>
    <jet-modal ref="modal" :show="show_modal" maxWidth="2xl" @close="show_modal = false">
        <div class="flex flex-col px-6 py-4 relative" v-if="lastCall">
            <!-- <template v-slot:title>
            <div class="flex justify-between text-gray-700 text-base font-medium">
                <span class="font-normal flex-grow text-sm"><span class="inline-block w-16 font-bold">Sent at:</span>
                    <span class="text-sm px-2 py-1 rounded-md bg-gray-100 font-normal">{{ new
                        Date(call.created_at).toISOString() }}</span></span>
                <span :class="['font-bold text-sm']">Response
                    code:
                    <span
                        :class="[call.response_status >= 200 && call.response_status < 300 ? 'bg-green-100 text-green-500' : 'bg-red-100 text-red-500', 'text-sm px-2 py-1 rounded-md font-bold']">{{
                        call.response_status }}</span></span>
            </div>
            <div class="flex justify-between text-gray-700 text-base font-medium mt-2">
                <span class="font-normal flex-grow truncate">
                    <span class="flex-shrink-0 text-sm inline-block w-16 font-bold">Endpoint:</span> <span
                        class="text-sm px-2 py-1 rounded-md bg-gray-100 font-normal truncate">{{
                        call.webhook_url }}</span></span>

            </div>
        </template> -->
            <!-- <template> -->
            <a href="#" class="absolute top-2 right-2 text-gray-500 hover:text-gray-700 text-base font-medium"
                @click.prevent.stop="close">
                <XMarkIcon class="size-5" />
            </a>

            <div class="flex justify-between text-gray-700 text-base font-medium mt-4">
                <span class="font-normal flex-grow text-sm"><span class="inline-block w-16 font-bold">Sent at:</span>
                    <span class="text-sm px-2 py-1 rounded-md bg-gray-100 font-normal">{{ new
                        Date(call.created_at).toISOString() }}</span></span>

                <!-- <vue-feather type="link-2" class="h-5 w-5 ml-2 self-center"></vue-feather> -->
            </div>
            <div class="flex justify-between text-gray-700 text-base font-medium mt-2">
                <span class="font-normal flex-grow truncate">
                    <span class="flex-shrink-0 text-sm inline-block w-16 font-bold">Endpoint:</span> <span
                        class="text-sm px-2 py-1 rounded-md bg-gray-100 font-normal truncate">{{
                        call.webhook_url }}</span></span>

            </div>


            <div class="h-[600px] overflow-y-auto flex flex-col mt-4">



                <!-- Reponse section -->
                <div class="text-gray-600 text-sm font-normal flex-grow flex flex-col mb-5">
                    <div class="flex flex-col flex-grow ">
                        <div class="flex flex-row font-bold flex-shrink-0 items-center justify-between">
                            <span>Response</span>
                            <span :class="['text-sm']">HTTP status code
                                :
                                <span
                                    :class="[call.response_status >= 200 && call.response_status < 300 ? ' text-green-500' : 'text-red-500', 'text-sm  font-bold']">{{
                                        call.response_status }}</span></span>
                        </div>
                        <div class="mt-1 flex-grow ">
                            <pre
                                class="whitespace-pre-wrap break-words bg-gray-100 text-xs p-4 rounded-md font-mono text-gray-800 overflow-auto h-full">
<code>{{ formatJson(call.response) }}</code>
</pre>
                        </div>
                    </div>
                </div>

                <!-- Headers section -->
                <div class="text-gray-600 text-sm font-normal mb-5 flex-shrink-0">
                    <div class="flex flex-col">
                        <div class="flex flex-row font-bold">Request Headers</div>
                        <div class="mt-1">
                            <pre
                                class="whitespace-pre-wrap break-words bg-gray-100 text-xs p-4 rounded-md font-mono text-gray-800 overflow-auto">
<code>{{ JSON.stringify(call.headers, null, 2)  }}</code>
</pre>
                        </div>
                    </div>
                </div>

                <!-- Payload section -->
                <div class="text-gray-600 text-sm font-normal flex-grow flex flex-col ">
                    <div class="flex flex-col flex-grow ">
                        <div class="flex flex-row font-bold flex-shrink-0">Request Payload</div>
                        <div class="mt-1 flex-grow ">
                            <pre
                                class="whitespace-pre-wrap break-words bg-gray-100 text-xs p-4 rounded-md font-mono text-gray-800 overflow-auto h-full">
<code>{{ JSON.stringify(call.payload, null, 2) }}</code>
</pre>
                        </div>
                    </div>
                </div>


            </div>

            <!-- </template> -->
            <!-- <template v-slot:footer>
            <div class="flex w-full flex-row justify-between">
                <div class="flex w-full">
                    <jet-button class="w-full place-content-center" @click.prevent.stop="close">
                        Close
                    </jet-button>
                </div>
            </div>
        </template> -->
        </div>
    </jet-modal>
</template>

<script>

import JetDialogModal from '@/Jetstream/DialogModal'
import JetModal from '@/Jetstream/Modal'
import JetButton from '@/Jetstream/Button'
import JetInput from '@/Jetstream/Input'
import JetLabel from '@/Jetstream/Label'
import { InformationCircleIcon, PlayIcon, CheckIcon, XMarkIcon } from "@heroicons/vue/24/solid";
import CopyField from '@/Components/UI/CopyField'
import Spinner from '@/Components/UI/Spinner'


export default {

    props: {
        // lastCall: {
        //     type: Object,
        //     required: true
        // }
    },

    components: {
        JetDialogModal, JetModal, JetButton, JetInput, JetLabel,
        InformationCircleIcon, CopyField, Spinner,
        PlayIcon, CheckIcon, XMarkIcon
    },

    data() {
        return {
            show_modal: false,
            lastCall: null
        }
    },

    created: function () {

    },

    methods: {

        open: function (call) {
            this.lastCall = call
            this.show_modal = true
            this.call = this.lastCall
        },
        close: function () {
            this.show_modal = false
        },
        formatJson(value) {
            try {
                const parsed = JSON.parse(value);
                return typeof parsed === 'object'
                    ? JSON.stringify(parsed, null, 2)
                    : parsed; // plain string or number
            } catch (e) {
                return value; // not JSON
            }
        }

    },

    computed: {

    }

}

</script>
